"use client";

import React from "react";
import { NavAudienceContext } from "dds/organisms/global-nav/nav-audience.client";
import { useUserRecognition } from "hooks/useRecognizedUserData";

/**
 * Tells the v3 GlobalNav which right-hand links to show — WAT-12640.
 *
 * Reuses v2's cookie rule (`useUserRecognition`, also called by
 * app/components/global-header/global-header-client.tsx). It runs after hydration, so the
 * served HTML is always the signed-out nav and is safe to edge-cache.
 */
export function V3NavAudience({ children }: { children: React.ReactNode }) {
  const { clientSideIsUserAuthenticated, clientSideIsRecognized } = useUserRecognition();
  const audience = clientSideIsUserAuthenticated ?
    "auth" :
    clientSideIsRecognized ?
      "recog" :
      null;

  return (
    <NavAudienceContext.Provider value={audience}>{children}</NavAudienceContext.Provider>
  );
}
